import React from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";

import { Form, Field } from "react-final-form";
import arrayMutators from "final-form-arrays";
// @ts-ignore
import createDecorator from "final-form-focus";

import Typography from "@material-ui/core/Typography";

import Grid from "@material-ui/core/Grid";

// @ts-ignore
import { TextField } from "final-form-material-ui";

import MenuItem from "@material-ui/core/MenuItem";

import SelectFieldRender from "./select-field-render";

import DateRangeDateTimeFieldRender from "./date-range-date-time-field-render";

import TreeSelectFieldRender from "./TreeSelectFieldRender";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { NodeClasses } from "./NodeClasses";

const focusOnErrors = createDecorator();

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
  })
);

interface Props {
  saveEntity: (values: any) => void;
  entity?: any;
  defaultValues?: any;
  cancelEdit?: any;
}

function WidgetUpdate(props: Props) {
  const { saveEntity, entity /*, defaultValues*/, cancelEdit } = props;
  const classes = useStyles(props);

  const onSubmit = async (componentValues: any) => {
    // console.log("Will submit WidgetUpdate", componentValues);
    const { /*id,*/ __typename, ...values } = componentValues;
    return saveEntity(values);
  };
  const validate = (values: any) => {
    const errors = {} as any;

    // TODO also subfields! (like widget layout)
    if (
      !("type" in values && values.type !== undefined && values.type !== null)
    ) {
      errors.type = "Required";
    }
    // if (
    //   !(
    //     "panelId" in values &&
    //     values.panelId !== undefined &&
    //     values.panelId !== null
    //   )
    // ) {
    //   errors.panelId = "Required";
    // }
    return errors;
  };

  return (
    <Form
      onSubmit={onSubmit}
      decorators={[focusOnErrors]}
      initialValues={entity}
      mutators={{
        ...arrayMutators,
      }}
      validate={validate}
      render={({ handleSubmit, pristine, invalid, submitting }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            {/* Hide ID */}
            <Grid item xs={12}>
              <Field
                name="title"
                type="text"
                component={TextField}
                label="Title"
                // margin="normal"
                autoFocus
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                name="type"
                component={SelectFieldRender}
                label="Type"
                fullWidth
                formControlProps={{
                  fullWidth: true,
                  required: true,
                }}
              >
                <MenuItem value="CHART">Chart</MenuItem>
                <MenuItem value="TABLE">Table</MenuItem>
                {/* <MenuItem value="MAP">Map</MenuItem> */}
                <MenuItem value="EVENT_LIST">Event List</MenuItem>
                <MenuItem value="LAST_VALUE">Last Value</MenuItem>
                <MenuItem value="GAUGE">Gauge</MenuItem>
              </Field>
            </Grid>

            <Field name="type" subscription={{ value: true }}>
              {({ input: { value: typeValue } }) =>
                !(
                  typeValue === "MAP" ||
                  typeValue === "LAST_VALUE" ||
                  typeValue === "GAUGE"
                ) ? (
                  <Grid item xs={12}>
                    <Field
                      name="interval"
                      component={DateRangeDateTimeFieldRender}
                      label="Date range"
                      fullWidth
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </Grid>
                ) : null
              }
            </Field>
            <Grid item xs={12}>
              <Field name="type" subscription={{ value: true }}>
                {({ input: { value: typeValue } }) => (
                  <Field
                    name="panelId"
                    component={TreeSelectFieldRender}
                    label="Data Source"
                    fullWidth
                    formControlProps={{
                      fullWidth: true,
                      // required: true
                    }}
                    nodeClasses={
                      typeValue === "LAST_VALUE" || typeValue === "GAUGE"
                        ? [NodeClasses.PANEL, NodeClasses.TAG]
                        : [NodeClasses.PANEL]
                    }
                  />
                )}
              </Field>
            </Grid>
            <Grid item xs={12} style={{ display: "none" }}>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="subtitle2">Layout</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Field
                        name="layout.x"
                        type="number"
                        parse={(value) =>
                          isNaN(parseInt(value, 10))
                            ? null
                            : parseInt(value, 10)
                        }
                        component={TextField}
                        label="X"
                        // margin="normal"
                        required
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        name="layout.y"
                        type="number"
                        parse={(value) =>
                          isNaN(parseInt(value, 10))
                            ? null
                            : parseInt(value, 10)
                        }
                        component={TextField}
                        label="Y"
                        // margin="normal"
                        required
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        name="layout.width"
                        type="number"
                        parse={(value) =>
                          isNaN(parseInt(value, 10))
                            ? null
                            : parseInt(value, 10)
                        }
                        component={TextField}
                        label="Width"
                        // margin="normal"
                        required
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        name="layout.height"
                        type="number"
                        parse={(value) =>
                          isNaN(parseInt(value, 10))
                            ? null
                            : parseInt(value, 10)
                        }
                        component={TextField}
                        label="Height"
                        // margin="normal"
                        required
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        name="layout.minWidth"
                        type="number"
                        parse={(value) =>
                          isNaN(parseInt(value, 10))
                            ? null
                            : parseInt(value, 10)
                        }
                        component={TextField}
                        label="Min Width"
                        // margin="normal"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        name="layout.maxWidth"
                        type="number"
                        parse={(value) =>
                          isNaN(parseInt(value, 10))
                            ? null
                            : parseInt(value, 10)
                        }
                        component={TextField}
                        label="Max Width"
                        // margin="normal"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        name="layout.minHeight"
                        type="number"
                        parse={(value) =>
                          isNaN(parseInt(value, 10))
                            ? null
                            : parseInt(value, 10)
                        }
                        component={TextField}
                        label="Min Height"
                        // margin="normal"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        name="layout.maxHeight"
                        type="number"
                        parse={(value) =>
                          isNaN(parseInt(value, 10))
                            ? null
                            : parseInt(value, 10)
                        }
                        component={TextField}
                        label="Max Height"
                        // margin="normal"
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
          <Button
            variant="contained"
            className={classes.button}
            color="primary"
            type="submit"
            disabled={submitting || invalid}
          >
            Submit
          </Button>
          {cancelEdit && (
            <Button
              variant="contained"
              className={classes.button}
              onClick={cancelEdit}
            >
              Cancel
            </Button>
          )}
        </form>
      )}
    />
  );
}

export default WidgetUpdate;
